// Formatadores pt-BR usados pelo motor (texto do plano) e pela tela.
// Fonte única: web/src/lib/format.ts reexporta daqui.

const BRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const BRL_INTEGER = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 0,
});

/** "R$ 1.234,56" — standard 2-decimal BRL. */
export function formatBRL(value: number): string {
  return BRL.format(value);
}

/** "R$ 1.235" — BRL without cents (compact dashboards / rounded totals). */
export function formatBRLInteger(value: number): string {
  return BRL_INTEGER.format(value);
}

/** ISO date "YYYY-MM-DD" → "dd/mm/yyyy". null/empty → "—"; unparseable → as-is.
 *  String-based (no Date()/timezone shift) — prefer this for ISO date columns. */
export function formatBrDate(iso: string | null): string {
  if (!iso) return "—";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : iso;
}
